module.exports = __webpack_public_path__ + "img/global-not_group.png?ee09d9e7";